import React from 'react';
import axios from 'axios';

import './index.scss';

import {getQueryParams, getCookie} from 'utils/utils';
import {hex_md5} from 'utils/crypto/md5';

export default class TimeDown extends React.Component {
    constructor(props) {
        super(props);
        this.queryParams = getQueryParams();
        this.duration = this.queryParams.dura || '';
        this.timeMaxLen = this.duration.length;
        this.state = {
            time: [],
            done: false
        };
    }
    componentDidMount() {
        if (this.duration) {
            this.startTime = new Date().getTime();
            this.timeDown(this.duration);
        }
    }
    completeTask() {
        const {tid: taskNum} = this.queryParams;
        const startTime = this.startTime;
        const endTime = new Date().getTime();
        const userName = (getCookie('_q') || '').slice(2);
        const queryParamStr = `endTime=${endTime}&startTime=${startTime}`;
        const sign = hex_md5(queryParamStr + `&userName=${userName}&taskNum=${taskNum}`);
        axios.get(`/marketing/spCoupon/completeTask.json?${queryParamStr}&taskNum=${taskNum}&sign=${sign}&groupId=2`)
            .then(res => res.data)
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
            });
        const QNRSK = window.QNRSK;
        QNRSK && QNRSK.manual('done_renwu_' + taskNum);
    }
    timeDown(count) {
        const self = this;
        const nextCount = count - 1;
        if (count < 0) {
            self.completeTask();
            self.setState({
                done: true
            });
            return;
        }
        let res = [];
        while (count > 0) {
            res.unshift(count % 10);
            count = parseInt(count / 10, 10);
        };
        const resLen = res.length;
        if (resLen < self.timeMaxLen) {
            for (let i = 0; i < self.timeMaxLen - resLen; i++) {
                res.unshift(0);
            }
        }
        self.setState({
            time: res
        });
        setTimeout(function() {
            self.timeDown(nextCount);
        }, 1000);
    }
    render() {
        const {time, done} = this.state;
        if (!this.duration) {
            return null;
        }
        return (
            <div className={'m-rest-time ' + (done ? 'rest-done' : '')}>
                <div className="bd">
                    <div className="g-flexbox">
                        {
                            time.map(item => {
                                return (
                                    <div key={item} className="flex item">{item}</div>
                                );
                            })
                        }
                    </div>
                    <div className="task-done">任务已完成</div>
                </div>
                <img className="bg-ft" src="//s.qunarzz.com/vacation_tuan/2020/519_redpacket/rest_time_ft.png" />
            </div>
        );
    }
}